import * as React from "react"
import { Typography } from "@mui/material"


export default function NotAllowedBlock({ symbol = "--", sx = {} }) {
    const styles = {
        text: {
            opacity: 0,
            color: "text.disabled",
            fontSize: "0.8rem",
            fontStyle: 'italic',
        },
        ...sx
    }

    return <Typography sx={styles}>
        {symbol}
    </Typography>
}